// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607010711/js/" + chunkId + "." + {"44":"69dd411b","225":"bbada0b0","481":"412c0682","486":"0fe07846","770":"20aa294d"}[chunkId] + ".0.3810526507618254.chunk.js";
};